$(function(){
   // コレクションタイトルから機種情報を取得
   if (myCollectionTitle.match( /\sケース$/ )) {
      $('#collection-item-src').show();
      if ($(window).width() >= 900) {
         $('#Search-In-Modal-Collection').focus();
      }
      //$('#Search-In-Modal-Collection').val(myCollectionTitle.replace(/\sケース$/, ''));
   }

   // sort_byセレクトにイベント追加（<title>, H1タイトルの変更）
   //   $('select[name="sort_by"]').on("change",function(){
   $(document).on('change', $('select[name="sort_by"]'),function () {
      // H1タイトルをセット
      changeTitle($('select[name="sort_by"]').val());
   })

});// end

function changeTitle(sort) {
   if ( sort == 'title-ascending' ) {
      $('#collection-title').html(' アルファベット順, A-Z');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + 'アルファベット順, A-Z &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + 'アルファベット順, A-Z');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + 'アルファベット順, A-Z');
   } else if ( sort == 'title-descending' ) {
      $('#collection-title').html(' アルファベット順, Z-A');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + 'アルファベット順, Z-A &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + 'アルファベット順, Z-A');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + 'アルファベット順, Z-A');
   } else if ( sort == 'price-ascending' ) {
      $('#collection-title').html(' 価格の安い順');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + '価格の安い順 &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + '価格の安い順');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + '価格の安い順');
   } else if ( sort == 'price-descending' ) {
      $('#collection-title').html(' 価格の高い順');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + '価格の高い順 &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + '価格の高い順');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + '価格の高い順');
   } else if ( sort == 'created-ascending' ) {
      $('#collection-title').html(' 古い商品順');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + '古い商品順 &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + '古い商品順');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + '古い商品順');
   } else if ( sort == 'created-descending' ) {
      $('#collection-title').html(' 新着順');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + '新着順 &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + '新着順');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + '新着順');
   } else if ( sort == 'best-selling' ) {
      $('#collection-title').html(' 人気ランキング(集計中)');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + '人気ランキング(集計中) &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + '人気ランキング(集計中)');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + '人気ランキング(集計中)');
   } else if ( sort == 'manual' ) {
      $('#collection-title').html(' 人気ランキング');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + '人気ランキング &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + '人気ランキング');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + '人気ランキング');
   } else {
      $('#collection-title').html(' 人気ランキング');
      $('title').html(collectionPageTitle.replace(collectionPageTitle, collectionPageTitle + ' ' + '人気ランキング &ndash; ' + collectionShopName));
      $("meta[property='og:title']").attr('content', collectionPageTitle + ' ' + '人気ランキング');
      $("meta[name='twitter:title']").attr('content', collectionPageTitle + ' ' + '人気ランキング');
   }
}
